import React from 'react';
import { Box } from '@chakra-ui/core';
import PropTypes from 'prop-types';
import SwiperCore, { EffectCoverflow } from 'swiper';

import {
  ThemeProvider,
  JssProvider,
} from 'react-jss';

import theme from '@Theme';

import 'swiper/swiper-bundle.min.css';

SwiperCore.use([EffectCoverflow]);

const LayoutDefault = ({ children }) => (
  <JssProvider>
    <ThemeProvider theme={theme}>
      {/* eslint-disable-next-line no-nested-ternary */}
      <Box as='main'>{children}</Box>
    </ThemeProvider>
  </JssProvider>
);

LayoutDefault.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default LayoutDefault;
